import { safeHTML } from "@lib/html";
import { NFTEventInfo } from "@models/event";

const EventDetailHostInfo = ({ info }: { info: NFTEventInfo }) => {
  return (
    <div className="w-full">
      {info.organizer && info.organizer.name && info.organizer.description && (
        <>
          <div className="text-2xl font-semibold mb-4 capitalize text-white">
            {info.organizer.name}
          </div>
          <p
            className="dark:text-secondary text-[#444] text-sm whitespace-pre-wrap"
            dangerouslySetInnerHTML={safeHTML(info.organizer.description)}
          ></p>
        </>
      )}
    </div>
  );
};

export default EventDetailHostInfo;
